// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({"1367": "ModelViewer","2257": "EthereumWallet","582": "NftSecondaryMarketModal","7530": "ActionToast","7581": "NftPdpZoomModal","8692": "RecentlyViewed",}[chunkId] || chunkId) + ".546.0.0." + {"1367": "a42a394cef766788","2257": "00bf77d8a49750ce","2973": "459dbdb5ba89f51e","582": "fa4a027c29b4fa56","7530": "b10e3496993404ee","7581": "f941fa4afb17071d","8692": "bb41778f79a19e82",}[chunkId] + ".css"
}